<template>
  <div class="PANEL d-flex">
    <img
        v-if="!$device.isMobile"
        :class="{DIM: !isTopPro}"
        class="FIVE-STAR-BADGE "
        src="@/assets/TopPro.svg"
        height="104"
        width="104"
    >
    <div class="d-flex fd-column w-100 p-r-6:t p-r-1:mo">
      <div class="d-flex">
        <img
            v-if="$device.isMobile"
            :class="{DIM: !isTopPro}"
            class="FIVE-STAR-BADGE "
            src="@/assets/TopPro.svg"
            height="40"
            width="40"
        >
        <div v-if="!isTopPro" class="p-t-3:t p-t-1:mo">
          <div class="p-l-1 d-flex:mo fd-column:mo">
            <span class="TITLE p-r-1">Want to become a Top Pro?</span>
            <span>
              <a
                  class="TOP-PRO-LINK"
                  :href="topProLink"
                  rel="noopener noreferrer"
                  target="_blank">Learn how to get this badge.</a>
            </span>
          </div>
        </div>
        <div v-else class="p-t-3:t p-t-1:mo">
          <span class="TITLE">Congratulations, you're a Top Pro this month!</span>
        </div>
      </div>
      <div class="p-1">
        <div :class="['MINIMUM-TOGGLE-ROW', { EXPANDED: showMinimumRequirements }]">
          <button class="MINIMUM-TOGGLE" type="button" @click="toggleMinimumRequirements">
            {{ minimumRequirementsLabel }}
            <vk-icon
                class="MINIMUM-CHEVRON"
                :name="minimumRequirementsIcon"
                size="12"
                unbounded
            />
          </button>
        </div>
        <div v-if="showMinimumRequirements">
          <div class="d-flex jc-between w-100">
            <div class="d-flex fd-column ai-center">
              <span class="VALUE">
                90%
              </span>
              <span class="REQUIREMENT">
                Lead Response Rate
              </span>
            </div>
            <div class="d-flex fd-column ai-center">
              <span class="VALUE">
                80%
              </span>
              <span class="REQUIREMENT">
                Lead Acceptance Rate
              </span>
            </div>
            <div class="d-flex fd-column ai-center">
              <span class="VALUE">
                4.5+
              </span>
              <span class="REQUIREMENT">
                Rating
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-pro-section',
  props: {
    isTopPro: {
      type: [Boolean],
      default: null,
      required: false,
    },
  },
  data () {
    return {
      showMinimumRequirements: false,
    };
  },
  computed: {
    minimumRequirementsLabel () {
      return this.showMinimumRequirements ? 'Hide minimum requirements' : 'View minimum requirements';
    },
    minimumRequirementsIcon () {
      return this.showMinimumRequirements ? 'chevronup' : 'chevrondown';
    },
    topProLink () {
      return `${this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN}/prohelpcenter/s/article/Top-Pro-Badge?login=true`;
    },
  },
  methods: {
    toggleMinimumRequirements () {
      this.showMinimumRequirements = !this.showMinimumRequirements;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .PANEL {
    position: relative;
    background-color: white;
    border: solid;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    margin-bottom: 2 * $unit;
    max-height: 20.25 * $unit;
    max-width: 97 * $unit;

    @include responsive(
      flex,
      0 0 35%,
    );
    &:first-of-type {
      @include wide {
        margin-right: $unit;
        flex: 1 0 65%
      }
    }
  }
  .DIM {
    opacity: .5;
  }
  .FIVE-STAR-BADGE {
    margin:  24px 18px 24px 32px;

     @include mobile-only {
      margin:  12px 8px 12px 12px;
    }
  }
  .REQUIREMENT {
    font-size: 2.25 * $unit;
    font-weight: 400;

    @include mobile-only {
      font-size: 1.5 * $unit;
      font-weight: 600;
    }
  }
  .TITLE {
    font-size: 2.5 * $unit;
    font-weight: 700;
    line-height: 2 * $unit;
  }
  .TOP-PRO-LINK {
    color: #F96302;
    font-size: 1.75 * $unit;
    font-weight: 400;
    line-height: 2 * $unit;
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }
  .VALUE {
    font-size: 2.5 * $unit;
    font-weight: 800;
  }
  .MINIMUM {
    font-size: 2.25 * $unit;
    font-weight: 700;

    @include mobile-only {
      font-size: 1.75 * $unit;
    }
  }
  .MINIMUM-TOGGLE {
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: #F96302;
    font-size: 1.75 * $unit;
    font-weight: 600;
    line-height: 2 * $unit;
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: $unit;
  }
  .MINIMUM-CHEVRON {
    margin-left: 0.5 * $unit;
  }
  .MINIMUM-TOGGLE-ROW {
    width: 100%;
    margin-bottom: $unit;
  }

  .MINIMUM-TOGGLE-ROW.EXPANDED {
    border-bottom: 1px solid #D9D9D9;
  }
</style>
